import type { TrackingAdapterSummary } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listAdapters } from '../gps.api';

export type AdapterCatalogueState = { status: 'loading' } | { status: 'loaded'; adapters: TrackingAdapterSummary[] } | { status: 'error' };

/** The adapters this release ships: a small fixed list, fetched whole (CLAUDE.md → Lists and tables). */
export function useAdapterCatalogue(): AdapterCatalogueState {
  const [state, setState] = useState<AdapterCatalogueState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listAdapters()
      .then((adapters) => !cancelled && setState({ status: 'loaded', adapters }))
      .catch(() => !cancelled && setState({ status: 'error' }));
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
